import Vue from "vue";
import VueRouter from "vue-router";
import sysPages from "./sys";
import authPages from "./auth";
import pubPages from "./pub";
import pltfPages from "./pltf";
import analysisPages from "./analysis";

Vue.use(VueRouter);

const Home = () => import("@/views/Home"); //后台首页
const Login = () => import("@/views/Login") // 登录页面

const routes = [
  { path: '/', redirect: '/login' },
  {
    path: '/optionModule',
    meta: { title: '选择系统' },
    component: () => import('@/views/OptionModule/index.vue')
  },
  {
    path: "/home", name: "Home", redirect: '/main', component: Home,
    children: [{
      path: "/main",
      name: "Main",
      meta: { fatherMenuName: '', menuName: '首页' },
      component: () => import("@/views/Home/Main.vue")
    },
    ...authPages, ...sysPages, ...pubPages, ...pltfPages, ...analysisPages,
    ]
  },
  { path: '/login', name: 'Login', component: Login },
  { path: "/register", name: 'Register', component: () => import("@/views/Register") },
  { path: "/arggment", name: 'Arggment', component: () => import("@/views/Register/Arggment.vue") },
  { path: "/findPassword", name: 'FindPassword', component: () => import("@/views/FindUserPassword") },
  {
    path: '/error',
    component: () => import('@/views/ErrorPage.vue'),
    meta: { title: 'Error', requiresAuth: true }
  },
  { path: '*', redirect: '/404' },
  // {
  //   path: '/404',
  //   name: '404',
  //   meta: { title: '404', requiresAuth: true },
  //   component: () => import('../views/Error404.vue')
  // },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
//push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default router;
